// CURP: 18 caracteres. 4 letras, fecha AAMMDD, sexo (H/M/X), 2 letras de
// entidad, 3 consonantes internas, homoclave (letra o dígito) y dígito
// verificador. Esta validación solo comprueba el FORMATO; la última palabra la
// tiene el backend (`curp_invalid`).
export const CURP_LENGTH = 18;
const CURP_FORMAT = /^[A-Z]{4}\d{6}[HMX][A-Z]{2}[A-Z]{3}[A-Z0-9]\d$/;

export const normalizeCurp = (value) => String(value || '').toUpperCase().replace(/\s+/g, '');

export const isValidCurp = (value) => CURP_FORMAT.test(normalizeCurp(value));

// "LOPA920315MJCPRZ05" -> "LOPA************05" (mismo enmascarado que el backend).
export const maskCurp = (value) => {
  const curp = normalizeCurp(value);
  if (curp.length <= 6) return '*'.repeat(curp.length);
  return `${curp.slice(0, 4)}${'*'.repeat(curp.length - 6)}${curp.slice(-2)}`;
};
